export enum LOGIN_SITE {
  USER = 'USER',
  OWNER = 'OWNER',
}
